import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as popoverActions from 'actions/popoverActions';
import Popover from 'components/Popover/Popover';

import Modal from 'components/Modal/Modal';
import { isIpad } from 'utils/utils';

/* istanbul ignore next */
const mapStateToProps = state => ({
  popoverState: state.popover || {},
  modal: state.modal,
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    popoverActionsBound: bindActionCreators(popoverActions, dispatch),
  };
}

export class PopoverLayout extends Component {
  static propTypes = {
    popoverState: PropTypes.object,
    popoverActionsBound: PropTypes.object,
    modal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  closePopover = (event) => {
    const { popoverActionsBound } = this.props;
    event.preventDefault();
    popoverActionsBound.hidePopover();
  };

  render() {
    const { popoverState, modal } = this.props;

    const body = popoverState.body;
    const isModalOpen = modal && modal.name && !modal.config.isSubPage;

    return (
      <div>
        {
          body && (
            (isIpad() && !isModalOpen) ? (
              <Modal onModalClose={this.closePopover}>
                <div>
                  <h1>{popoverState.title}</h1>
                  { typeof body === 'string' ? <div dangerouslySetInnerHTML={{ __html: body }} /> : body }
                </div>
              </Modal>
            ) : (
              <Popover
                closePopover={this.closePopover}
                popoverState={popoverState}
                title={popoverState.title}
                hasCloseButton={popoverState.hasCloseButton}
                body={body}
                position={popoverState.position}
              />
            )
          )
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PopoverLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/PopoverLayout/PopoverLayout.jsx
 **/